'use client';

import { css } from 'styled-components';

export const BreakpointsValues = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

export const breakpointsTokens = {
  xs: '--screen-xs',
  sm: '--screen-sm',
  md: '--screen-md',
  lg: '--screen-lg',
  xl: '--screen-xl',
  xxl: '--screen-xxl',
};

export const generateBreakpointsToken = (values: Record<keyof typeof Breakpoints, string | number>) => {
  return css`
    ${breakpointsTokens.xs}: ${values.xs};
    ${breakpointsTokens.sm}: ${values.sm};
    ${breakpointsTokens.md}: ${values.md};
    ${breakpointsTokens.lg}: ${values.lg};
    ${breakpointsTokens.xl}: ${values.xl};
    ${breakpointsTokens.xxl}: ${values.xxl};
  `;
};

export const Breakpoints = {
  xs: 0,
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1416px',
};

export const ContainerMaxWidth = {
  xs: '320px',
  sm: '540px',
  md: '720px',
  lg: '1140px',
  xl: '1320px',
  xxl: '1980px',
};

export const ModalMaxWidth = {
  sm: '500px',
  md: '800px',
  lg: '1320px',
};
